<template>
    <div ref="rootElement">
        <div
            class="container-fluid mr-0 ml-0 p-0 input d-flex"
            :class="compact ? 'comiss-compact' : { 'flex-column': true, 'w-100': isMobile, 'flex-column align-items-start gap-2': isMobile, 'mt-3': !needDecision, 'gap-2': needDecision && !isMobile, 'gap-4': !needDecision }"
        >
            <div class="d-flex" :class="compact ? 'comiss-compact-col' : { 'w-100': true, 'gap-2': true, 'flex-column': isMobile || (rootWidth <= 768 && !needDecision), 'flex-row': needDecision && !isMobile, 'flex-row justify-content-between': rootWidth > 768 }">
                <div class="p-0 mt-0 d-flex align-items-center justify-content-between">
                    <label class="lh20 neue-roman text-nowrap" :class="compact ? 'fsp14 color-black' : { 'primary-grey fsp16 col-6': rootWidth > 768, 'fsp14 lh20 col-12': (rootWidth <= 768 && !needDecision) || isMobile }">
                        {{ $t('components.service.Comiss.1') }}
                    </label>
                </div>
                <div class="input-wrapper loader-r-cc p-0 mt-0" :class="compact ? 'comiss-compact-input' : { 'col-12': rootWidth <= 768 && !needDecision, 'flex-grow-1': needDecision && !isMobile, 'col-6': rootWidth > 768 || (needDecision && !isMobile) }">
                    <loading :active="loader" :is-full-page="false" :height="20" :width="50" loader="dots" color="#008D3E" :opacity="0"/>
                    <InputSimple :class="{ 'border-orange': needDecision, 'w328': needDecision && !isMobile }" :disabled="true" id="commis_total" :dataValue="total ? total + ' ' + curr : ''"/>
                </div>
            </div>
            <div class="d-flex" :class="compact ? 'comiss-compact-col' : { 'w-100': true, 'gap-2': true, 'flex-column': isMobile || (rootWidth <= 768 && !needDecision), 'justify-content-between': rootWidth > 768 && !needDecision, 'justify-content-end': needDecision && !isMobile, 'flex-row': rootWidth > 768 && !needDecision, 'flex-row': rootWidth > 768 }">
                <div class="input-wrapper p-0" :class="compact ? '' : { 'col-12': rootWidth <= 768 && !needDecision }">
                    <label class="input-label" :class="compact ? 'fsp14 color-black' : { 'col-12': rootWidth > 768 && !needDecision, 'fsp16 primary-grey': rootWidth > 768, 'fsp14 lh20': (rootWidth <= 768 && !needDecision) || isMobile }">{{ $t('components.service.Comiss.2') }}</label>
                </div>
                <div v-if="hasInfoBreakdown" class="col-6 input-wrapper p-0 mt-0">
                    <Button class="col-12" :id="'comiss-3-'+id" :name="$t('components.service.Comiss.3')" type="btn-outline-warning" @click="info = !info"/>
                </div>
                <div v-else class="input-wrapper loader-r-cc p-0 mt-0" :class="compact ? 'comiss-compact-input' : { 'col-12': rootWidth <= 768 && !needDecision, 'col-6': rootWidth > 768 }">
                    <loading :active="loader" :is-full-page="false" :height="20" :width="50" loader="dots" color="#008D3E" :opacity="0"/>
                    <InputSimple :class="{ 'border-orange': needDecision, 'w328': needDecision && !isMobile }" :disabled="true" id="commis_f" :dataValue="comiss"/>
                </div>
            </div>
        </div>
        <div v-if="enrollment" class="mt-3">
            <div>
                <label class="fsp14 lh20 neue-roman mb8">{{ $t('components.service.Comiss.4') }}</label>
            </div>
            <div class="input-wrapper loader-r-cc p-0 mt-0">
                <loading :active="loader" :is-full-page="false" :height="20" :width="50" loader="dots" color="#008D3E" :opacity="0"/>
                <InputSimple :class="{ 'border-orange': needDecision }" :disabled="true" id="commis_enroll" :dataValue="to_enrollment"/>
            </div>
        </div>
        <div v-if="info" class="row container-fluid mr-0 ml-0 mt-3 p-0 g-3 align-items-center">
            <div class="col-sm-3 p-0 mt-0"></div>
            <div class="table-responsive col-sm-9 p-0 m-0">
                <table class="table table-borderless neue-roman m-0">
                    <tbody>
                        <tr v-for="(row, index) in infoData" :key="index">
                            <td class="p-0 d-flex flex-row align-items-center justify-content-start">
                                <span :id="'comiss-i-1-'+id+'-'+index">{{ `${row.type_name}: ${row.value} ${row.curr_text}` }}</span>
                                <span v-if="row.comment" :id="'comiss-i-2-'+id+'-'+index" class="fst-italic ml-1 fs_09">({{ row.comment }})</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import InputSimple from '@/components/service/InputSimple';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Button from '@/components/service/Button';

/**
 * Адаптеры для расчёта комиссии. Каждый адаптер — три части:
 *   - endpoint: имя endpoint'а на back (axios.post('<endpoint>', ...))
 *   - buildPayload(params, cmd_name): формирует тело запроса
 *   - parseBody(body): нормализует ответ в { commission, total, to_enrollment, info }
 *
 * Чтобы добавить новый микросервис с расчётом комиссии:
 *   1) Заведи endpoint в back/App/Controllers/CommissionController.php + роут
 *   2) Добавь сюда запись с ключом-`mode` и парсером ответа
 *   3) В компоненте-родителе укажи :mode="'<key>'" и :params="{...}"
 */
const FLAT_CALC_ROW = (body, tableName) => {
    const row = body?.tables?.[tableName]?.colvalues?.[0];
    if (!row) return null;
    return {
        commission: row.commission ?? '0',
        total: row.gross ?? '0',
        to_enrollment: row.net ?? '0',
        info: [],
    };
};

const ADAPTERS = {
    // msTransfer POST /api/transfer/user/calculate
    'mstransfer-user': {
        endpoint: 'CommissionTransferUser',
        buildPayload(params) {
            return {
                amount: String(params?.amount ?? ''),
                keyt_pay: String(params?.keyt_pay ?? ''),
                shop_info: String(params?.shop_info ?? ''),
            };
        },
        parseBody(body) {
            return FLAT_CALC_ROW(body, 'transfer_user_calculate');
        },
    },

    // msTransfer POST /api/transfer/self/calculate
    'mstransfer-self': {
        endpoint: 'CommissionTransferSelf',
        buildPayload(params) {
            return {
                amount: String(params?.amount ?? ''),
                keyt_pay: String(params?.keyt_pay ?? ''),
                keyt_shop: String(params?.keyt_shop ?? ''),
            };
        },
        parseBody(body) {
            return FLAT_CALC_ROW(body, 'transfer_self_calculate');
        },
    },

    // Legacy путь — сохранён для pay_momental, burn_custom_curr, emission_custom_curr,
    // pay_inflow_finish и прочих cmd_name, ещё не переведённых на отдельные МС.
    legacy: {
        endpoint: 'GetComiss',
        buildPayload(params, cmdName) {
            const cleaned = { ...(params || {}) };
            if (cleaned.protect == '1' && !cleaned.protect_code) {
                delete cleaned.protect;
                delete cleaned.protect_day;
            }
            return { cmd_params: cleaned, cmd_name: cmdName };
        },
        parseBody(body) {
            const components = body?.table?.colvalues ?? [];
            const commission = String(components.reduce((acc, c) => acc + Number(c.value || 0), 0));
            const info = body?.tables?.[0]?.colvalues ?? [];
            const changes = body?.tables?.[1]?.colvalues ?? [];
            const abs = (c) => (c?.change != null ? c.change.toString().replace(/^-/, '') : '');
            let total = '';
            let to_enrollment = '';
            if (changes.length === 1) {
                total = abs(changes[0]);
            } else if (changes.length > 1) {
                const [a, b] = changes;
                if (Number(a.change) < 0) {
                    total = abs(a);
                    to_enrollment = abs(b);
                } else {
                    total = abs(b);
                    to_enrollment = abs(a);
                }
            }
            return { commission, total, to_enrollment, info };
        },
    },
};

export default {
    components: { InputSimple, Loading, Button },

    props: {
        sum:           { type: [Number, String, Boolean] },
        id:            { type: [String, Boolean], default: 'def_comiss' },
        curr:          { type: String },
        precision:     { type: String },
        params:        { type: [Object, Boolean] },
        cmd_name:      { type: [String, Boolean] },
        enrollment:    { type: Boolean },
        compact:       { type: Boolean },
        needDecision:  { type: Boolean },
        onMountStart:  { type: Boolean },
        off_watcher:   { type: Boolean },
        /**
         * Adapter — ключ из ADAPTERS. По умолчанию 'legacy' (GetComiss).
         * Для новых интеграций используй 'mstransfer-user' / 'mstransfer-self'
         * или зарегистрируй свой адаптер.
         */
        mode:          { type: String, default: null },
    },

    data() {
        return {
            timeout: null,
            comiss: '',
            total: '',
            to_enrollment: '',
            loader: false,
            info: false,
            infoData: [],
            rootWidth: 0,
            resizeObserver: null,
        };
    },

    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        adapter() {
            return ADAPTERS[this.mode] || ADAPTERS.legacy;
        },
        hasInfoBreakdown() {
            return Array.isArray(this.infoData) && this.infoData.length > 0;
        },
    },

    watch: {
        sum(newS) {
            if (this.off_watcher) return;
            this.getCommiss(newS);
        },
    },

    mounted() {
        if (this.onMountStart && this.sum) {
            this.getCommiss(this.sum);
        }
        this.$nextTick(() => {
            if (!this.$refs.rootElement) return;
            this.measureWidth();
            this.resizeObserver = new ResizeObserver(() => this.measureWidth());
            this.resizeObserver.observe(this.$refs.rootElement);
        });
    },

    beforeUnmount() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.timeout) window.clearTimeout(this.timeout);
    },

    methods: {
        // Публичный API: используется родителями через ref (см. Transfer.vue → reComiss).
        getCommiss(newS) {
            if (this.timeout) window.clearTimeout(this.timeout);
            this.timeout = setTimeout(() => this.runCalc(newS), 1000);
        },

        // Публичный API: используется родителями через ref (см. Transfer.vue → setSummWarn).
        getTotal() {
            return this.total;
        },

        runCalc(newS) {
            this.$emit('updateParentState', false);
            this.$emit('onSuccess', false);

            if (!this.isValidSum(newS)) {
                this.resetState();
                return;
            }

            this.beginLoading();
            const payload = this.adapter.buildPayload(this.params || {}, this.cmd_name);

            this.axios
                .post(this.adapter.endpoint, { no_loader: true, data: payload })
                .then((res) => this.handleResponse(res))
                .catch(() => {
                    this.loader = false;
                    this.$emit('updateParentState', this.$t('components.service.Comiss.5'));
                });
        },

        isValidSum(value) {
            return (
                typeof value !== 'undefined' &&
                value !== '' &&
                value !== false &&
                !(typeof value === 'string' && value.endsWith('.'))
            );
        },

        handleResponse(res) {
            this.loader = false;
            const body = res?.data?.body;
            if (!body || (body.result != 0 && body.result !== '0' && body.result !== 0)) {
                this.$emit(
                    'updateParentState',
                    body?.result_text || this.$t('components.service.Comiss.5')
                );
                return;
            }

            const parsed = this.adapter.parseBody(body);
            if (!parsed || (!parsed.total && parsed.total !== '0')) {
                this.$emit('updateParentState', this.$t('components.service.Comiss.5'));
                return;
            }

            this.applyParsed(parsed);
        },

        applyParsed({ commission, total, to_enrollment, info }) {
            this.comiss = commission;
            this.total = total;
            this.to_enrollment = to_enrollment || '';
            this.infoData = info || [];
            // Авто-раскрытие info-разбивки, если она есть в ответе
            this.info = this.infoData.length > 0;

            this.$emit('updateParentState', false);
            this.$emit('onSuccess', true);
            this.$emit('updateComiss', this.comiss);
        },

        beginLoading() {
            this.info = false;
            this.infoData = [];
            this.loader = true;
            this.comiss = false;
            this.total = false;
            this.to_enrollment = false;
        },

        resetState() {
            this.comiss = '';
            this.total = '';
            this.to_enrollment = '';
            this.info = false;
            this.infoData = [];
            this.$emit('updateParentState', false);
        },

        measureWidth() {
            if (this.$refs.rootElement) this.rootWidth = this.$refs.rootElement.offsetWidth;
        },
    },
};
</script>

<style lang="scss" scoped>
.input {
    font-family: 'HelveticaNeue roman';
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }
}
.mt-1 { margin: 0 !important; }
.require { color: red; }
.vld-overlay {
    justify-content: flex-start;
    height: 20px;
    position: absolute;
    top: 23%;
    left: 10%;
    bottom: 28%;
}
.loader-r-cc {
    min-height: 20px;
    position: relative;
}
.comiss-compact {
    flex-direction: row;
    gap: 16px;
    margin-top: 0;
}
.comiss-compact-col {
    flex: 1;
    flex-direction: column;
}
.comiss-compact-input {
    width: 100%;
    flex: none;
}
.color-black { color: #000; }
.border-orange {
    border-color: $dark-orange;
    background-color: inherit !important;
    color: black !important;

    :deep(input:disabled) {
        background-color: inherit !important;
        color: black !important;
    }
}
.w328 { width: 328px !important; }
</style>
